export const baseUrl = "https://wapi.otoplan.com.tr/";
//export const baseUrl = "https://localhost:5001/";

/**
 * Dosya adresi çözümleyici.
 *
 * Backend artık dosya alanlarını MinIO'ya imzalanmış MUTLAK adres olarak döner
 * (ör. https://cdn.otoplan.com.tr/otoplan/prod/teklif/files/abc.jpg?X-Amz-...).
 * Bu yüzden başına baseUrl eklenmemelidir.
 *
 * Geçiş güvenliği için: değer hâlâ göreli gelirse (eski kayıt / gözden kaçan alan)
 * eskisi gibi baseUrl ile birleştirilir.
 */
export const fileUrl = (value?: unknown): string => {
  // Bazı model tipleri aynı alanı hem string hem File[] olarak tanımlıyor (form yüklemesi için).
  // Yalnızca string değerler adrese çevrilir, diğerleri boş döner.
  if (typeof value !== "string" || value.length === 0) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return baseUrl + value.replace(/^\//, "");
};
